<template>
  <div class="textLight--text">
    <v-row>
      <v-col>
        <ValidationObserver ref="observer">
          <v-row>
            <v-col cols="4" md="3" class="d-flex align-center">
              <p class="ma-0 text-start font-weight-thin">
                {{ $t("user.registration.organization") }}
              </p></v-col
            >
            <v-col cols="8" md="9">
              <div class="d-flex justify-space-between align-center">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  style="width: 100%"
                >
                  <v-autocomplete
                    hide-details
                    @click="registerErr = null"
                    v-model="organization"
                    :error-messages="errors"
                    dense
                    :items="organizations"
                    :search-input.sync="orgSearch"
                    auto-select-first
                    item-value="_id"
                    flat
                    solo
                    outlined
                    :label="$t('user.registration.selectOrganization')"
                    class="rounded-lg"
                    background-color="transparent"
                    :filter="customLocalisedAutoCompleteFilter"
                  >
                    <template slot="selection" slot-scope="data">
                      {{ getLocalisedValue(data.item.name) }}
                    </template>
                    <template v-slot:item="{ item }">
                      <div
                        class="d-flex flex-column text-start"
                        style="width: 100%"
                      >
                        {{ getLocalisedValue(item.name) }}
                        <v-divider></v-divider>
                      </div>
                    </template>
                    <template v-slot:append-item>

                      <div v-intersect="onIntersectOrg" />

                    </template>
                  <template v-slot:append-item>

                    <div v-intersect="onIntersectCourse" />

                  </template>

                  </v-autocomplete>
                </validation-provider>

                <template v-if="havePermissionCreateOrganization">
                  <v-btn
                    v-if="!hideAddBtn"
                    depressed
                    outlined
                    min-width="0"
                    class="pa-3 ms-3"
                    @click="$emit('add')"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="hideAddBtn"
                    outlined
                    depressed
                    min-width="0"
                    class="pa-3 ms-3"
                    @click="$emit('hide')"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </template>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" md="3" class="d-flex align-center">
              <p class="ma-0 text-start font-weight-thin">
                {{ $t("course.course") }}
              </p></v-col
            >
            <v-col cols="8" md="9">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                  hide-details
                  @click="registerErr = null"
                  @input="setCourseDuration"
                  v-model="course"
                  :error-messages="errors"
                  dense
                  outlined
                  :items="courses"
                  :search-input.sync="courseSearch"
                  auto-select-first
                  item-value="_id"
                  flat
                  solo
                  :label="$t('user.registration.selectCourse')"
                  class="rounded-lg"
                  background-color="transparent"
                  :filter="customLocalisedAutoCompleteFilter"
                >
                  <template slot="selection" slot-scope="data">
                    {{ getLocalisedValue(data.item.title) }}
                  </template>

                  <template v-slot:item="{ item }">
                    <div
                      class="d-flex flex-column text-start"
                      style="width: 100%"
                    >
                      {{ getLocalisedValue(item.title) }}
                      <v-divider></v-divider>
                    </div>
                  </template>
                </v-autocomplete>
              </validation-provider>
            </v-col>
          </v-row>

          <v-row v-if="isCourseOffline">
            <v-col cols="4" md="3" class="d-flex align-center">
              <p class="ma-0 text-start font-weight-thin text-truncate">
                {{ $t("course.trainer") }}
              </p></v-col
            >
            <v-col cols="8" md="9">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                  hide-details
                  :error-messages="errors"
                  v-model="trainer"
                  outlined
                  @click="registerErr = null"
                  dense
                    :items="trainersList"
                    :search-input.sync="trainerSearch"
                    auto-select-first
                    :loading="loadingTrainers"
                    :no-data-text="loadingTrainers ? 'Loading trainers...' : 'No trainers found'"
                  item-value="_id"
                  :item-text="getEmployeeText"
                  flat
                  solo
                  :label="$t('user.trainers.selectTrainer')"
                  class="rounded-lg"
                  background-color="transparent"
                  :filter="customLocalisedAutoCompleteFilter"
                >
                  <template v-slot:item="{ item }">
                    <div class="d-flex justify-start">
                      {{
                        `${item.name || ""} ${item.lastName || ""} ${
                          item.email ? "(" + item.email + ")" : ""
                        }`
                      }}
                    </div>
                  </template>
                </v-autocomplete>
              </validation-provider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" md="3" class="d-flex align-center">
              <p class="ma-0 text-start font-weight-thin">
                {{ $t("course.courseDuration") }}
              </p></v-col
            >
            <v-col cols="8" md="9">
              <v-row>
                <v-col cols="12" sm="5" class="pe-sm-0">
                  <v-menu
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-text-field
                          hide-details
                          v-model="formattedStartDate"
                          :error-messages="errors"
                          placeholder="DD/MM/YYYY"
                          class="rounded-lg"
                          outlined
                          dense
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon slot="append" color="textLight">
                            mdi-calendar-blank-outline
                          </v-icon></v-text-field
                        >
                      </validation-provider>
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="startDate"
                      no-title
                      @input="startDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  class="px-sm-0 d-flex align-center"
                  v-if="$vuetify.breakpoint.smAndUp"
                >
                  <div style="width: 100%" class="font-weight-thin">
                    {{ $t("user.registration.to") }}
                  </div>
                </v-col>
                <v-col cols="12" sm="5" class="ps-sm-0">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-text-field
                      hide-details
                      :error-messages="errors"
                      class="rounded-lg"
                      placeholder="DD/MM/YYYY"
                      v-model="endDate"
                      outlined
                      dense
                      readonly
                    >
                      <v-icon slot="append" color="textLight">
                        mdi-calendar-blank-outline
                      </v-icon></v-text-field
                    >
                  </validation-provider>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" md="3" class="d-flex align-center">
              <p class="ma-0 text-start font-weight-thin">
                {{ $t("course.courseDetails.certificateValidity") }}
              </p></v-col
            >
            <v-col cols="8" md="9">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-text-field
                  hide-details
                  type="number"
                  min="0"
                  v-model.number="certificateValidity"
                  :error-messages="errors"
                  class="rounded-lg text-field-prefix-opacity"
                  outlined
                  dense
                  :prefix="certificateValidityPrefix"
                >
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
        </ValidationObserver>

        <v-row v-if="users.length">
          <v-col cols="12">
            <v-card flat class="rounded-lg primary--text">
              <v-row class="ma-1">
                <v-col cols="1">
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("user.registration.slNo") }}
                  </p>
                </v-col>

                <v-col cols="2"
                  ><p class="ma-0 text-start font-weight-thin">
                    {{ $t("user.registration.employeeName") }}
                  </p></v-col
                >
                <v-col cols="2"
                  ><p class="ma-0 text-start font-weight-thin">
                    {{ $t("user.department") }}
                  </p></v-col
                >
                <v-col cols="2"
                  ><p class="ma-0 text-start font-weight-thin">
                    {{ $t("user.designation") }}
                  </p></v-col
                >
                <v-col cols="2"
                  ><p class="ma-0 text-start font-weight-thin">
                    {{ $t("user.registration.civilOrPassport") }}
                  </p></v-col
                >
                <v-col cols="3"
                  ><p class="ma-0 text-start font-weight-thin">
                    {{ $t("user.email") }}
                  </p></v-col
                >
              </v-row>
            </v-card>
          </v-col>
          <v-col
            v-for="(user, index) in users"
            :key="index"
            cols="12"
            class="py-1"
          >
            <v-card flat class="rounded-lg textLight--text">
              <v-row class="ma-1" align="center">
                <v-col cols="1"
                  ><p class="ma-0 text-start font-weight-medium">
                    {{ index + 1 }}
                  </p></v-col
                >
                <v-col cols="2"
                  ><p class="ma-0 text-start font-weight-medium text-ellipse-2">
                    {{ `${user.firstName || ""} ${user.lastName || ""}` }}
                  </p></v-col
                >
                <v-col cols="2"
                  ><p class="ma-0 text-start font-weight-medium text-ellipse-2">
                    {{ user.department }}
                  </p></v-col
                >
                <v-col cols="2"
                  ><p class="ma-0 text-start font-weight-medium text-ellipse-2">
                    {{ user.designation }}
                  </p></v-col
                >
                <v-col cols="2"
                  ><p class="ma-0 text-start font-weight-medium text-ellipse-2">
                    {{ user.civilIdOrPassport }}
                  </p></v-col
                >
                <v-col cols="3">
                  <div class="d-flex">
                    <v-icon
                      v-if="hasOrganizationMismatch(user.email) || hasDuplicateCourseWarning(user.email)"
                      x-small
                      color="warning"
                      class="pe-1"
                    >
                      mdi-alert-outline
                    </v-icon>

                    <p
                      class="ma-0 text-start font-weight-medium text-ellipse-2"
                    >
                      {{ user.email }}
                    </p>

                    <v-spacer></v-spacer>

                    <v-icon color="textLight" @click="deleteUser(index)">
                      mdi-close
                    </v-icon>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <ValidationObserver ref="userObserver">
          <div class="my-3">
            <v-row>
              <v-col cols="4" md="3" class="d-flex align-center">
                <p class="ma-0 text-start font-weight-thin">
                  {{ $t("user.registration.employeeName") }}
                </p></v-col
              >
              <v-col cols="8" md="9">
                <v-combobox
                  @click="registerErr = null"
                  hide-details
                  append-icon=""
                  :error="nameErr"
                  @input="nameErr = false"
                  ref="nameComboBox"
                  v-model="employeeName"
                  :items="employees"
                  :search-input.sync="empNameSearch"
                  :item-text="getEmployeeText"
                  :filter="customEmployeeFilter"
                  item-value="_id"
                  outlined
                  class="rounded-lg"
                  dense
                >
                  <template v-slot:item="{ item }">
                    <div class="d-flex justify-start">
                      {{
                        `${item.name || ""} ${item.lastName || ""} (${
                          item.civilIdOrPassport
                        })`
                      }}
                    </div>
                  </template>
                <template v-slot:append-item>

                  <div v-intersect="onIntersectEmp" />

                </template>

                </v-combobox>
                <!-- <v-text-field
                @click="registerErr = null"
                class="rounded-lg"
                v-model="name"
                dense
                :error="nameErr"
                @input="nameErr = false"
                hide-details
                outlined
              ></v-text-field> -->
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="3" class="d-flex align-center">
                <p class="ma-0 text-start font-weight-thin">
                  {{ $t("user.registration.civilOrPassport") }}
                </p></v-col
              >
              <v-col cols="8" md="9">
                <v-combobox
                  @click="registerErr = null"
                  @input="
                    () => {
                      (civilIdOrPassportErr = false),
                        (civilIdOrPassportDuplicate = false);
                    }
                  "
                  hide-details
                  append-icon=""
                  ref="civilIdOrPassportComboBox"
                  :error="civilIdOrPassportErr"
                  v-model="employeeCivilIdOrPassport"
                  :items="employees"
                  :search-input.sync="empCivilSearch"
                  item-value="civilIdOrPassport"
                  item-text="civilIdOrPassport"
                  :filter="customCivilFilter"
                  outlined
                  class="rounded-lg"
                  dense
                  :return-object="false"
                >
                  <template v-slot:item="{ item }">
                    <div class="d-flex justify-start">
                      {{ item.civilIdOrPassport }}
                    </div>
                  </template>
                  <template v-slot:append-item>
                    <div v-intersect="onIntersectEmp" />
                  </template>
                </v-combobox>
                <!-- <v-text-field
                v-model="civilIdOrPassport"
                @click="registerErr = null"
                :error="civilIdOrPassportErr"
                @input="
                  () => {
                    (civilIdOrPassportErr = false),
                      (civilIdOrPassportDuplicate = false);
                  }
                "
                class="rounded-lg"
                dense
                hide-details
                outlined
              ></v-text-field> -->
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="3" class="d-flex align-center">
                <p class="ma-0 text-start font-weight-thin">
                  {{ $t("user.email") }}
                </p></v-col
              >
              <v-col cols="8" md="9">
                <validation-provider v-slot="{ errors }" rules="email">
                  <v-combobox
                    @click="registerErr = null"
                    @input="
                      () => {
                        emailErr = false;
                      }
                    "
                    hide-details
                    append-icon=""
                    ref="emailComboBox"
                    :error="emailErr"
                    :error-messages="errors"
                    v-model="employeeEmail"
                    :items="employees"
                    :search-input.sync="empEmailSearch"
                    item-value="email"
                    item-text="email"
                    :filter="customEmailFilter"
                    outlined
                    class="rounded-lg"
                    dense
                    :return-object="false"
                  >
                    <template v-slot:item="{ item }">
                      <div class="d-flex justify-start">
                        {{ item.email }}
                      </div>
                    </template>
                    <template v-slot:append-item>
                      <div v-intersect="onIntersectEmp" />
                    </template>
                  </v-combobox>
                  <!-- <v-text-field
                  :error-messages="errors"
                  v-model="email"
                  :error="emailErr"
                  @click="registerErr = null"
                  @input="
                    () => {
                      emailErr = false;
                    }
                  "
                  class="rounded-lg"
                  dense
                  hide-details
                  outlined
                ></v-text-field> -->
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="3" class="d-flex align-center">
                <p class="ma-0 text-start font-weight-thin">
                  {{ $t("user.designation") }}
                </p></v-col
              >
              <v-col cols="8" md="9">
                <v-text-field
                  @click="registerErr = null"
                  v-model="designation"
                  class="rounded-lg"
                  dense
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="3" class="d-flex align-center">
                <p class="ma-0 text-start font-weight-thin">
                  {{ $t("user.department") }}
                </p></v-col
              >
              <v-col cols="8" md="9">
                <v-text-field
                  @click="registerErr = null"
                  v-model="department"
                  class="rounded-lg"
                  dense
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </ValidationObserver>

        <!--        <v-row>
          <v-col cols="4" md="3" class="d-flex align-center">
            <p class="ma-0 text-start font-weight-thin">
              {{ $t("user.registration.courseRate") }}
            </p></v-col
          >
          <v-col cols="8" md="9">
            <v-text-field
              color="#9e9e9e"
              v-model.number="courseRate"
              :prefix="defaultPrice + '|'"
              type="number"
              @click="registerErr = null"
              class="rounded-lg"
              dense
              hide-details
              outlined
              :min="0"
              @keypress="
                numberInputEventFilter({ event: $event, isFloat: true })
              "
              @paste="numberInputEventFilter({ event: $event, isFloat: true })"
            ></v-text-field
          ></v-col>
          &lt;!&ndash; <v-col cols="4" md="1" class="d-flex align-center">
            <p class="ma-0 text-start font-weight-thin">
              {{ $t("user.registration.discount") }}
            </p></v-col
          >
          <v-col cols="8" md="2">
            <v-text-field
              v-model.number="discount"
              type="number"
              @click="registerErr = null"
              class="rounded-lg"
              dense
              hide-details
              outlined
            ></v-text-field
          ></v-col>
          <v-col cols="4" md="2" class="d-flex align-center">
            <p class="ma-0 text-start font-weight-thin">
              {{ $t("user.registration.invoiceAmount") }}
            </p></v-col
          >
          <v-col cols="8" md="2">
            <v-text-field
              v-model.number="invoiceAmount"
              type="number"
              @click="registerErr = null"
              class="rounded-lg"
              dense
              hide-details
              outlined
            ></v-text-field
          ></v-col> &ndash;&gt;
        </v-row>-->

        <v-row>
          <v-col cols="4" md="3" class="d-flex align-center">
            <p class="ma-0 text-start font-weight-thin">
              {{ $t("user.registration.remarks") }}
            </p></v-col
          >
          <v-col cols="8" md="9">
            <v-textarea
              v-model="remarks"
              outlined
              @click="registerErr = null"
              class="rounded-lg"
              dense
              hide-details
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-checkbox
              class="ma-0"
              v-model="isCourseOffline"
              :label="$t('user.registration.isCourseOffline')"
              color="primary"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-checkbox
              class="ma-0"
              v-model="attendanceDownload"
              :label="$t('user.registration.downloadAttendanceSheet')"
              color="primary"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" v-if="registerErr">
            <p class="pa-0 ma-0 error--text">
              {{ registerErr }}
            </p>
          </v-col>
          <v-col cols="12" v-if="civilIdOrPassportDuplicate">
            <p class="pa-0 ma-0 error--text">
              {{ $t("civilOrPassportAlreadyAdded") }}
            </p>
          </v-col>

          <v-col cols="12" md="6">
            <v-btn
              depressed
              block
              color="primary"
              style="text-transform: unset"
              class="rounded-lg font-weight-normal"
              @click="addUser"
            >
              {{ $t("user.registration.addEmployee") }}
            </v-btn>
          </v-col>

          <v-col cols="12" md="6">
            <v-btn
              depressed
              block
              color="primary"
              style="text-transform: unset"
              class="rounded-lg font-weight-normal"
              @click="register"
              :loading="btnLoading"
            >
              {{ $t("user.registration.register") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  <!-- Duplicate Course Warning Dialog -->
  <v-dialog v-model="duplicateWarningDialog" max-width="850px" persistent>
    <v-card class="rounded-lg">
      <v-card-title class="headline d-flex align-center pb-2">
        <v-icon color="warning" class="me-2" size="28">mdi-alert-circle</v-icon>
        <span class="warning--text font-weight-medium">Duplicate Course Warning</span>
      </v-card-title>
      
      <v-card-text class="pt-4 text-start">
        <p class="subtitle-1 textLight--text mb-4">
          The following employee(s) are already registered for or have completed this course earlier:
        </p>
        
        <v-simple-table fixed-header height="300px" class="border rounded-lg mb-4">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-start">Employee Name</th>
                <th class="text-start">Organization</th>
                <th class="text-start">Course</th>
                <th class="text-start">Course Start Date</th>
                <th class="text-start">Course End Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(warn, idx) in duplicateWarnings" :key="idx">
                <td>{{ `${warn.firstName || ""} ${warn.lastName || ""}`.trim() }}</td>
                <td>
                  {{ warn.organizationName || warn.organization || getLocalisedValue(selectedOrganizationInfo ? selectedOrganizationInfo.name : null) }}
                </td>
                <td>
                  {{ warn.courseTitle || warn.course || getLocalisedValue(selectedCourseInfo ? selectedCourseInfo.title : null) }}
                </td>
                <td>
                  {{ warn.startDate ? $moment(warn.startDate).format("DD/MM/YYYY") : formattedStartDate }}
                </td>
                <td>
                  {{ warn.expiryDate ? $moment(warn.expiryDate).format("DD/MM/YYYY") : (warn.endDate ? $moment(warn.endDate).format("DD/MM/YYYY") : endDate) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-actions class="pa-4 pt-0">
        <v-btn text @click="duplicateWarningDialog = false" class="rounded-lg">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="warning"
          depressed
          class="rounded-lg px-4"
          @click="bypassRegistration"
        >
          Register Anyway
        </v-btn>
        <v-btn
          color="primary"
          depressed
          class="rounded-lg px-4"
          @click="skipDuplicatesAndRetry"
        >
          Skip & Proceed
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import "../../core-module/util/validationRules";
import { createEmployees } from "../../user-module/methods/createEmployees";
import { updateEmployee } from "../../user-module/methods/updateEmployee";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

import { bulkDownloadAttendanceSheets } from "@/app/user-module/helpers/attendenceSheetHelper";

export default {
  props: {
    
    
    selectedOrganization: {
      type: String,
    },
    hideAddBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      
      courses: [],
      courseSearch: null,
      courseSkip: 0,
      courseTotal: 0,
      organizations: [],
      orgSearch: null,
      orgSkip: 0,
      orgTotal: 0,
      trainerSearch: null,
      trainerSkip: 0,
      trainerTotal: 0,
      empSearch: null,
      empNameSearch: null,
      empCivilSearch: null,
      empEmailSearch: null,
      empSkip: 0,
      empTotal: 0,
      empSearchTimeout: null,

      organization: null,
      course: null,
      certificateValidity: null,
      trainer: null,
      name: null,
      email: null,
      civilIdOrPassport: null,
      designation: null,
      department: null,
      companyEmail: null,
      users: [],
      startDate: "",
      startDateMenu: false,
      endDate: "",
      courseDuration: null,
      courseRate: null,
      discount: null,
      invoiceAmount: null,
      remarks: null,
      defaultPrice: 0,
      organizationErr: false,
      courseErr: false,
      nameErr: false,
      emailErr: false,
      companyEmailErr: false,
      civilIdOrPassportErr: false,
      registerErr: null,
      btnLoading: false,
      civilIdOrPassportDuplicate: false,
      employeeName: null,
      employeeEmail: null,
      employeeCivilIdOrPassport: null,
      employees: [],
      allEmployees: [],
      trainerId: null,
      attendanceDownload: true,
      subscriberInfo: null,
      isCourseOffline: true,
      certificateValidityPrefix: "",
      trainersList: [],
      loadingTrainers: false,
      errorData: {
        employees: [],
      },
      duplicateWarningDialog: false,
      duplicateWarnings: [],
      pendingInputData: null,
    };
  },
  apollo: {

    getTrainings() {
      return {
        query: require("../../course-module/api/query/getTrainings.gql"),
        debounce: 300,
        variables() {
          return {
            limit: 50,
            skip: this.courseSkip,
            filterInput: this.courseSearch ? { search: this.courseSearch, approvalStatus: "APPROVED", isActive: true } : { approvalStatus: "APPROVED", isActive: true }
          };
        },
        result({ data }) {
          if (data && data.getTrainings && data.getTrainings.trainings) {
             let res = data.getTrainings.trainings;
             if (this.courseSkip === 0) {
                this.courses = res;
             } else {
                this.courses.push(...res);
             }
             this.courseTotal = data.getTrainings.totalCount || 0;
          }
        }
      };
    },
    getOrganizations() {
      return {
        query: require("../../organization-module/api/query/getOrganizations.gql"),
        debounce: 300,
        variables() {
          return {
            limit: 50,
            skip: this.orgSkip,
            filterInput: this.orgSearch ? { search: this.orgSearch } : null
          }
        },
        result({ data }) {
           if (data && data.getOrganizations && data.getOrganizations.organizations) {
              let res = data.getOrganizations.organizations.filter(x => x.isActive === true);
              if (this.orgSkip === 0) {
                 this.organizations = res;
              } else {
                 this.organizations.push(...res);
              }
              this.orgTotal = data.getOrganizations.totalCount || 0;
           }
        }
      };
    },

    getEmployees() {
      return {
        query: require("../../user-module/api/query/getEmployees.gql"),
        debounce: 300,
        variables() {
          return {
            limit: 50,
            skip: this.empSkip,
            filterInput: {
              ...(this.organization ? { organization: this.organization } : {}),
              ...(this.empSearch ? { search: this.empSearch } : {}),
            }
          }
        },
        result({ data, loading }) {
          if (data?.getEmployees) {
            let res = data.getEmployees.employees.map(employee => {
              let obj = {};
              obj._id = employee._id;
              obj.organization = employee?.organization?._id;
              obj.name = employee?.user?.firstName;
              obj.lastName = employee?.user?.lastName;
              obj.email = employee?.user?.email;
              obj.civilIdOrPassport = employee?.user?.civilIdOrPassport;
              obj.designation = employee?.designation;
              obj.department = employee?.department;
              obj.subRoles = employee?.user?.subRoles
                ? employee.user.subRoles
                : [];
              return obj;
            });
            if (this.empSkip === 0) {
              this.employees = res;
            } else {
              this.employees.push(...res);
            }
            this.empTotal = data.getEmployees.totalCount || 0;
            this.allEmployees = this.employees;
          }
        },
      };
    },
    getSubRoles() {
      return {
        query: require("../../user-module/api/query/getSubRoles.gql"),
        variables: { limit: 0, skip: 0 },
        result({ data, loading }) {
          if (data && data.getSubRoles && data.getSubRoles.subRoles) {
            this.trainerId = data.getSubRoles.subRoles.find(
              x => x.name === "TRAINER"
            )?._id;
          }
        },
      };
    },
    getSubscriberProfile() {
      return {
        query: require("../../user-module/api/query/getSubscriberProfile.gql"),
        result({ data }) {
          if (data?.getSubscriberProfile) {
            this.subscriberInfo = data.getSubscriberProfile;
          }
        },
      };
    },
  },
  computed: {
    selectedOrganizationInfo() {
      return this.organizations.find(obj => obj._id === this.organization);
    },
    selectedOrganizationTrainingValidities() {
      return this.selectedOrganizationInfo?.trainingValidities ?? [];
    },
    selectedCourseInfo() {
      return this.courses.find(obj => obj._id === this.course);
    },
    selectedCourseCertificateValidity() {
      if (this.selectedOrganizationTrainingValidities.length) {
        const courseInfo = this.selectedOrganizationTrainingValidities.find(
          obj => obj.training?._id === this.course
        );

        if (courseInfo?.certificateValidity) {
          return courseInfo.certificateValidity;
        }
      }

      return this.selectedCourseInfo?.certificateValidity;
    },
    formattedStartDate: {
      get() {
        return this.startDate
          ? this.$moment(this.startDate).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.startDate = value;
      },
    },
    havePermissionCreateOrganization() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_ORGANIZATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    trainers() {
      return this.trainerId && this.allEmployees?.length
        ? this.allEmployees
            .map(obj => {
              let result = obj.subRoles.find(
                role => role._id === this.trainerId
              );
              if (result) return { ...obj };
            })
            .filter(filterObj => filterObj !== undefined)
        : [];
    },
  },
  watch: {

  
    orgSearch(val) {
      this.orgSkip = 0;
    },
    courseSearch(val) {
      this.courseSkip = 0;
    },
    trainerSearch(val) {
      // Skip when val is null — this happens when Vuetify internally resets
      // the search input after items load or an item is selected, NOT when
      // the user is actively typing. Prevents infinite re-fetch loop.
      if (val === null || val === undefined) return;

      // If a trainer is already selected and the search matches their name,
      // don't re-fetch (user is just viewing their selection)
      if (this.trainer) {
        const selected = this.trainersList.find(t => t._id === this.trainer);
        if (selected && val === this.getEmployeeText(selected)) return;
      }

      if (this.trainerSearchTimeout) clearTimeout(this.trainerSearchTimeout);
      this.trainerSearchTimeout = setTimeout(() => {
        this.trainerSkip = 0;
        this.fetchTrainers();
      }, 300);
    },
    empSearch(val) {
      this.empSkip = 0;
    },
    empNameSearch(val) {
      if (val === null || val === undefined) return;
      if (this.employeeName && typeof this.employeeName === "object") {
        if (val === this.getEmployeeText(this.employeeName)) return;
      }
      if (this.empSearchTimeout) clearTimeout(this.empSearchTimeout);
      this.empSearchTimeout = setTimeout(() => {
        this.empSearch = val;
        this.empSkip = 0;
      }, 300);
    },
    empCivilSearch(val) {
      if (val === null || val === undefined) return;
      if (this.employeeCivilIdOrPassport && typeof this.employeeCivilIdOrPassport === "string") {
        const selected = this.employees.find(e => e.civilIdOrPassport === this.employeeCivilIdOrPassport);
        if (selected && val === selected.civilIdOrPassport) return;
      }
      if (this.empSearchTimeout) clearTimeout(this.empSearchTimeout);
      this.empSearchTimeout = setTimeout(() => {
        this.empSearch = val;
        this.empSkip = 0;
      }, 300);
    },
    empEmailSearch(val) {
      if (val === null || val === undefined) return;
      if (this.employeeEmail && typeof this.employeeEmail === "string") {
        const selected = this.employees.find(e => e.email === this.employeeEmail);
        if (selected && val === selected.email) return;
      }
      if (this.empSearchTimeout) clearTimeout(this.empSearchTimeout);
      this.empSearchTimeout = setTimeout(() => {
        this.empSearch = val;
        this.empSkip = 0;
      }, 300);
    },

    organization() {
      this.employeeName =
        this.employeeEmail =
        this.employeeCivilIdOrPassport =
          null;
      this.name = "";
      this.lastName = "";
      this.email = "";
      this.civilIdOrPassport = "";
      this.designation = "";
      this.department = "";
      this.remarks = "";
      this.users = [];
      // Reset employee list so the API re-fetches filtered by new organization
      this.empSkip = 0;
      this.employees = [];
      this.setCertificateValidity();
    },
    employeeName() {
      if (this.employeeName) {
        if (typeof this.employeeName === "object") {
          this.name = this.employeeName.name;
          this.lastName = this.employeeName.lastName;
          this.email = this.employeeEmail = this.employeeName.email;
          this.civilIdOrPassport = this.employeeCivilIdOrPassport =
            this.employeeName.civilIdOrPassport;
          this.designation = this.employeeName.designation;
          this.department = this.employeeName.department;
        } else {
          this.name = this.employeeName;
          this.lastName = null;
          if (this.email) {
            if (this.checkIsExistingEmail(this.email))
              this.email = this.employeeEmail = null;
          }
          if (this.civilIdOrPassport) {
            if (this.checkIsExistingCivilIdOrPassport(this.civilIdOrPassport))
              this.civilIdOrPassport = this.employeeCivilIdOrPassport = null;
          }
        }
      } else {
        this.name = null;
        this.lastName = null;
        if (this.email) {
          if (this.checkIsExistingEmail(this.email))
            this.email = this.employeeEmail = null;
        }
        if (this.civilIdOrPassport) {
          if (this.checkIsExistingCivilIdOrPassport(this.civilIdOrPassport))
            this.civilIdOrPassport = this.employeeCivilIdOrPassport = null;
        }
      }
    },
    employeeEmail() {
      if (this.employeeEmail) {
        let checkIsExisting = this.checkIsExistingEmail(this.employeeEmail);
        if (checkIsExisting) {
          this.employeeName = checkIsExisting;
        } else {
          this.email = this.employeeEmail;
          if (typeof this.employeeName === "object") this.employeeName = null;
        }
      } else {
        this.email = null;
        if (typeof this.employeeName === "object") this.employeeName = null;
      }
    },
    employeeCivilIdOrPassport() {
      if (this.employeeCivilIdOrPassport) {
        let checkIsExisting = this.checkIsExistingCivilIdOrPassport(
          this.employeeCivilIdOrPassport
        );
        if (checkIsExisting) {
          this.employeeName = checkIsExisting;
        } else {
          this.civilIdOrPassport = this.employeeCivilIdOrPassport;
          if (typeof this.employeeName === "object") this.employeeName = null;
        }
      } else {
        this.civilIdOrPassport = null;
        // if (typeof this.employeeName === "object") this.employeeName = null;
      }
    },
    selectedOrganization() {
      if (this.selectedOrganization) {
        this.organization = this.selectedOrganization;
      }
    },
    startDate() {
      if (this.courseDuration && this.startDate) this.setEndDate();
    },
    trainerId(val) {
    if (val) {
      this.fetchTrainers();
    }
    }
  },
  methods: {

    onIntersectOrg(isIntersecting) {
      if (isIntersecting && this.organizations.length < this.orgTotal && !this.$apollo.queries.getOrganizations.loading) {
        this.orgSkip += 50;
      }
    },
    onIntersectCourse(isIntersecting) {
      if (isIntersecting && this.courses.length < this.courseTotal && !this.$apollo.queries.getTrainings.loading) {
        this.courseSkip += 50;
      }
    },
    onIntersectTrainer(isIntersecting) {
      if (isIntersecting && this.trainersList.length < this.trainerTotal && !this.loadingTrainers) {
        this.trainerSkip += 50;
        this.fetchTrainers();
      }
    },
    onIntersectEmp(isIntersecting) {
      if (isIntersecting && this.employees.length < this.empTotal && !this.$apollo.queries.getEmployees.loading) {
        this.empSkip += 50;
      }
    },
    refetchOrganizations() {
      this.$apollo.queries.getOrganizations.refetch({});
    },

    hasOrganizationMismatch(email) {
      return (
        this.errorData.employees?.findIndex(
          x => x.user?.email?.toLowerCase() === email?.toLowerCase()
        ) >= 0
      );
    },
    hasDuplicateCourseWarning(email) {
      return (
        this.duplicateWarnings?.findIndex(
          x => x.email?.toLowerCase() === email?.toLowerCase()
        ) >= 0
      );
    },
    getEmployeeText(item) {
      if (!item) return "";
      const firstName = item.name || item.firstName || item.user?.firstName || "";
      const lastName = item.lastName || item.user?.lastName || "";
      return `${firstName} ${lastName}`.trim();
    },
    checkIsExistingEmail(email) {
      if (email) {
        let isExisting = this.employees.find(obj => obj.email === email) || this.allEmployees?.find(obj => obj.email === email);
        if (isExisting) return isExisting;
        else return false;
      }
    },
    checkIsExistingCivilIdOrPassport(val) {
      if (val) {
        let isExisting = this.employees.find(
          obj => obj.civilIdOrPassport === val
        ) || this.allEmployees?.find(
          obj => obj.civilIdOrPassport === val
        );
        if (!isExisting && typeof val === "string" && val.trim().length >= 3) {
          const valClean = val.trim().toLowerCase();
          isExisting = this.employees.find(
            obj => obj.civilIdOrPassport && obj.civilIdOrPassport.toLowerCase().includes(valClean)
          ) || this.allEmployees?.find(
            obj => obj.civilIdOrPassport && obj.civilIdOrPassport.toLowerCase().includes(valClean)
          );
        }
        if (isExisting) return isExisting;
        else return false;
      }
    },
    customCivilFilter(item, queryText, itemText) {
      if (!queryText) return true;
      const q = queryText.toString().toLowerCase().trim();
      if (typeof item === "string") {
        return item.toLowerCase().indexOf(q) > -1;
      }
      const civil = (item?.civilIdOrPassport || "").toString().toLowerCase();
      const name = `${item?.name || ""} ${item?.lastName || ""}`.toLowerCase();
      const email = (item?.email || "").toString().toLowerCase();
      const text = (itemText || "").toString().toLowerCase();
      return (
        text.indexOf(q) > -1 ||
        civil.indexOf(q) > -1 ||
        name.indexOf(q) > -1 ||
        email.indexOf(q) > -1
      );
    },
    customEmployeeFilter(item, queryText, itemText) {
      if (!queryText) return true;
      const q = queryText.toString().toLowerCase().trim();
      if (typeof item === "string") {
        return item.toLowerCase().indexOf(q) > -1;
      }
      const name = `${item?.name || ""} ${item?.lastName || ""}`.toLowerCase();
      const civil = (item?.civilIdOrPassport || "").toString().toLowerCase();
      const email = (item?.email || "").toString().toLowerCase();
      const text = (itemText || "").toString().toLowerCase();
      return (
        text.indexOf(q) > -1 ||
        name.indexOf(q) > -1 ||
        civil.indexOf(q) > -1 ||
        email.indexOf(q) > -1
      );
    },
    customEmailFilter(item, queryText, itemText) {
      if (!queryText) return true;
      const q = queryText.toString().toLowerCase().trim();
      if (typeof item === "string") {
        return item.toLowerCase().indexOf(q) > -1;
      }
      const email = (item?.email || "").toString().toLowerCase();
      const civil = (item?.civilIdOrPassport || "").toString().toLowerCase();
      const name = `${item?.name || ""} ${item?.lastName || ""}`.toLowerCase();
      const text = (itemText || "").toString().toLowerCase();
      return (
        text.indexOf(q) > -1 ||
        email.indexOf(q) > -1 ||
        civil.indexOf(q) > -1 ||
        name.indexOf(q) > -1
      );
    },
    setCourseDuration() {
      this.courseErr = false;

      this.courseDuration = this.selectedCourseInfo?.duration;

      this.defaultPrice = this.selectedCourseInfo?.price
        ? this.selectedCourseInfo.price
        : 0;

      if (this.courseDuration && this.startDate) this.setEndDate();

      this.setCertificateValidity();
    },
    setCertificateValidity() {
      if (this.selectedCourseCertificateValidity) {
        this.certificateValidity = this.selectedCourseCertificateValidity;
        this.certificateValidityPrefix = `${this.selectedCourseCertificateValidity} | `;
      }
    },
    setEndDate() {
      this.endDate = this.$moment(this.startDate)
        .add(this.courseDuration, "days")
        .subtract(1, "days")
        .format("DD/MM/YYYY");
    },
    formatDateServer(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    deleteUser(i) {
      this.users.splice(i, 1);
    },
    async addUser() {
      const isEmailValid = await this.$refs.userObserver.validate();

      this.$refs["nameComboBox"].blur();
      this.$refs["emailComboBox"].blur();
      this.$refs["civilIdOrPassportComboBox"].blur();
      this.$nextTick(async () => {
        this.nameErr = false;
        this.civilIdOrPassportErr = false;
        this.emailErr = false;
        // this.companyEmailErr = false;
        if (this.civilIdOrPassport) {
          this.civilIdOrPassportDuplicate = this.users.some(
            el => el.civilIdOrPassport === this.civilIdOrPassport?.trim()
          );

          if (!this.civilIdOrPassportDuplicate) {
          this.users.push({
            firstName: this.name,
            lastName: this.lastName,
            email: this.email?.trim(),
            // companyEmail: this.companyEmail,
            civilIdOrPassport: this.civilIdOrPassport?.trim(),
            designation: this.designation,
              department: this.department,
          });
          this.name = "";
          this.lastName = "";
          this.email = "";
          this.employeeName = null;
          this.employeeEmail = null;
          this.employeeCivilIdOrPassport = null;
          this.civilIdOrPassport = "";
          this.designation = "";
            this.department = "";
          }
          if (this.civilIdOrPassportDuplicate) this.civilIdOrPassportErr = true;
        } else {
          if (!this.name) this.nameErr = true;
          if (!this.civilIdOrPassport) this.civilIdOrPassportErr = true;
        }
      });
    },
    async localFetchEmployees(val) {
      // Organization filtering is now handled at the API level via the
      // getEmployees query variables. This method is kept for compatibility.
      this.empSkip = 0;
      this.employees = [];
    },
    downloadAttendancePdf(batch) {
      let selectedTrainerName = "";
      if (this.trainer && this.isCourseOffline) {
        if (typeof this.trainer === "object") {
          selectedTrainerName = this.getEmployeeText(this.trainer);
        } else {
          const found =
            this.trainersList?.find(obj => String(obj._id) === String(this.trainer)) ||
            this.allEmployees?.find(obj => String(obj._id) === String(this.trainer)) ||
            this.employees?.find(obj => String(obj._id) === String(this.trainer));
          if (found) {
            selectedTrainerName = this.getEmployeeText(found);
          }
        }
      }

      let data = [
        {
          subscriberInfo: this.subscriberInfo,
          batchNumber: batch?.UID,
          courseTitle: this.course
            ? this.getLocalisedValue(this.selectedCourseInfo?.title)
            : "",
          date: this.$moment(this.startDate).format("DD MMM YYYY"),
          trainer: selectedTrainerName,
          company: this.organization
            ? this.getLocalisedValue(this.selectedOrganizationInfo?.name)
            : "",
          remarks: this.remarks ? this.remarks : "",
          employees: this.users.length
            ? this.users.map(obj => {
                let newObj = {};
                newObj.firstName = `${obj.firstName || ""} ${
                  obj.lastName || ""
                }`;
                newObj.email = obj.email;
                newObj.civilIdOrPassport = obj.civilIdOrPassport;
                newObj.designation = obj.designation;
                return newObj;
              })
            : this.name
            ? [
                {
                  firstName: `${this.name || ""} ${this.lastName || ""}`.trim(),
                  email: this.email,
                  civilIdOrPassport: this.civilIdOrPassport,
                  designation: this.designation,
                },
              ]
            : [],
        },
      ];

      return bulkDownloadAttendanceSheets({
        attendanceSheets: data,
      });
    },

    async register() {
      const isValid = await this.$refs.observer.validate();
      this.registerErr = null;

      // 1. If we have users in the list (from Excel or Add Employee)
      if (this.users.length > 0) {
        if (!isValid) {
          this.organizationErr = !this.organization;
          this.courseErr = !this.course;
          return;
        }

          this.btnLoading = true;
          let inputData = {
            users: this.users.map(obj => {
              return {
                firstName: obj.firstName,
                email: obj.email,
                civilIdOrPassport: obj.civilIdOrPassport,
                designation: obj.designation,
              };
            }),
            organization: this.organization,
            training: this.course,
            trainingDuration: this.courseDuration,
            certificateValidity: this.certificateValidity,
            trainer: this.trainer && this.isCourseOffline ? this.trainer : null,
            startDate: this.startDate,
            endDate: this.formatDateServer(this.endDate),
            unitPrice: this.defaultPrice,
            customPrice:
              this.courseRate != null
                ? this.getFloat(this.courseRate)
                : this.defaultPrice,
            remarks: this.remarks,
            trainingMode: this.isCourseOffline ? "OFFLINE" : "ONLINE",
            // invoice: {
            //   price: this.courseRate ? this.courseRate : this.defaultPrice,
            //   // discount: this.discount,
            //   // invoiceAmount: this.invoiceAmount,
            //   remarks: this.remarks,
            // },
          };

          this.submitRegistration(inputData);
        }
        // 2. If list is empty, register the currently typed single user directly
        else {
          const isEmailValid = await this.$refs.userObserver.validate();
          this.nameErr = !this.name;
          this.civilIdOrPassportErr = !this.civilIdOrPassport;

          if (!isValid) {
            this.organizationErr = !this.organization;
            this.courseErr = !this.course;
            return;
          }

          if (isEmailValid && this.name && this.civilIdOrPassport) {
            this.btnLoading = true;
            let inputData = {
              users: [
                {
                  firstName: this.name,
                  email: this.email?.trim(),
                  civilIdOrPassport: this.civilIdOrPassport?.trim(),
                  designation: this.designation,
                },
              ],
              organization: this.organization,
              training: this.course,
              trainingDuration: this.courseDuration,
              certificateValidity: this.certificateValidity,
              trainer: this.trainer && this.isCourseOffline ? this.trainer : null,
              startDate: this.startDate,
              endDate: this.formatDateServer(this.endDate),
              unitPrice: this.defaultPrice,
              customPrice:
                this.courseRate != null
                  ? this.getFloat(this.courseRate)
                  : this.defaultPrice,
              remarks: this.remarks,
              trainingMode: this.isCourseOffline ? "OFFLINE" : "ONLINE",
              // invoice: {
              //   price: this.courseRate ? this.courseRate : this.defaultPrice,
              //   // discount: this.discount,
              //   // invoiceAmount: this.invoiceAmount,
              //   remarks: this.remarks,
              // },
            };

            this.submitRegistration(inputData);
          }
        }
    },

    async submitRegistration(inputData) {
          this.errorData.employees = [];

          await createEmployees(inputData).then(async result => {
            if (result.error) {
             this.btnLoading = false;
              if (result.error.includes("ALREADY_EXIST"))
                this.registerErr = this.$t("inputRules.emailAlreadyExist");
              else if (result.error.includes("DUPLICATE_COURSE_WARNING")) {
                try {
                  let cleanedError = result.error;
                  if (cleanedError.startsWith("Error: ")) {
                    cleanedError = cleanedError.substring(7);
                  }
                  const errorObj = JSON.parse(cleanedError);
                  this.duplicateWarnings = errorObj?.extra || [];
                  this.pendingInputData = inputData;
                  this.duplicateWarningDialog = true;
                } catch (e) {
                  console.error(e);
                  this.registerErr = this.$t("somethingWentWrong");
                }
              } else if (result.error.includes("ORGANIZATION_MISMATCH_ERROR")) {
                try {
                  let cleanedError = result.error;
                  if (cleanedError.startsWith("Error: ")) {
                    cleanedError = cleanedError.substring(7);
                  }
                  this.errorData.employees = JSON.parse(cleanedError)
                    ?.extra?.filter(x => x.employee)
                    ?.map(x => x.employee);
                } catch (_) {}

                this.registerErr = this.$t(
                  "user.registration.organizationMismatchError"
                );
              } else this.registerErr = this.$t("somethingWentWrong");
            } else {
          // If we had department values in the UI, update them post-creation
          const createdEmployees = result.data?.employees || [];
          if (createdEmployees.length) {
            const updatePromises = [];
            
            createdEmployees.forEach(emp => {
              const createdEmail = emp.user?.email?.toLowerCase();
              if (createdEmail) {
                let deptVal = "";
                const originalUser = this.users.find(u => u.email?.toLowerCase() === createdEmail);
                if (originalUser && originalUser.department) {
                  deptVal = originalUser.department;
                } else if (this.email?.toLowerCase() === createdEmail && this.department) {
                  deptVal = this.department;
                }
                
                if (deptVal) {
                  updatePromises.push(
                    updateEmployee({
                      id: emp._id,
                      input: { department: deptVal }
                    }).catch(err => console.error("Failed to update department", err))
                  );
                }
              }
            });

            if (updatePromises.length) {
              await Promise.all(updatePromises);
            }
          }

              if (this.attendanceDownload === true) {
                let pdfResult = await this.downloadAttendancePdf(
                  result.data.batch
                );
            this.btnLoading = false;
                if (pdfResult) location.reload();
                else this.registerErr = this.$t("attendanceDownloadFailed");
              } else {
            this.btnLoading = false;
                location.reload();
              }
            }
          });
    },
    async fetchTrainers() {
      this.loadingTrainers = true;
      try {
        const result = await this.$apollo.query({
          query: require("../../user-module/api/query/getEmployees.gql"),
          variables: {
            limit: 50,
            skip: this.trainerSkip,
            filterInput: { subRole: this.trainerId, search: this.trainerSearch || null }
          }
        });
        if (result?.data?.getEmployees) {
          let res = result.data.getEmployees.employees.map(emp => ({
            _id: emp._id,
            name: emp?.user?.firstName,
            lastName: emp?.user?.lastName,
            email: emp?.user?.email
          }));
          if (this.trainerSkip === 0) {
            this.trainersList = res;
          } else {
            this.trainersList.push(...res);
          }
          this.trainerTotal = result.data.getEmployees.totalCount || 0;
        }
      } catch (e) {
        console.error(e);
      }
      this.loadingTrainers = false;
    },
    addImportedUsers(importedUsers) {
      if (importedUsers && importedUsers.length) {
        importedUsers.forEach(user => {
          const isEmailDup = this.users.some(el => el.email.toLowerCase() === user.email.toLowerCase());
          const isCivilDup = this.users.some(el => el.civilIdOrPassport.toLowerCase() === user.civilIdOrPassport.toLowerCase());
          if (!isEmailDup && !isCivilDup) {
            this.users.push(user);
          }
        });
      }
    },
    async bypassRegistration() {
      this.duplicateWarningDialog = false;
      if (this.pendingInputData) {
        this.btnLoading = true;
        const inputData = {
          ...this.pendingInputData,
          bypassDuplicateCheck: true,
        };
        await this.submitRegistration(inputData);
      }
    },
    async skipDuplicatesAndRetry() {
      this.duplicateWarningDialog = false;
      if (this.pendingInputData && this.duplicateWarnings?.length) {
        const duplicateEmails = this.duplicateWarnings.map(w => w.email?.toLowerCase());
        
        // Filter out duplicate users from inputData
        const remainingUsers = this.pendingInputData.users.filter(
          u => !duplicateEmails.includes(u.email?.toLowerCase())
        );

        // Update this.users too so the list reflects the removal
        this.users = this.users.filter(
          u => !duplicateEmails.includes(u.email?.toLowerCase())
        );

        if (remainingUsers.length > 0) {
          this.btnLoading = true;
          const inputData = {
            ...this.pendingInputData,
            users: remainingUsers,
          };
          await this.submitRegistration(inputData);
        } else {
          // If it was a single employee or all were skipped, clear the single input fields
          if (this.users.length === 0) {
            this.name = "";
            this.lastName = "";
            this.email = "";
            this.employeeName = null;
            this.employeeEmail = null;
            this.employeeCivilIdOrPassport = null;
            this.civilIdOrPassport = "";
            this.designation = "";
            this.department = "";
          }
          this.$toast.info("All duplicate employees were skipped.");
        }
      }
    }
  },
};
</script>
